import ProductAttachments from '@app/ProductAttachments/View'

export default function install(Vue) {
  Vue.component(ProductAttachments.name, ProductAttachments)
}
